import React from "react";
import PriceInfo from "components/CheckoutProductPricePicker/PriceInfo";
import classnames from "classnames";
import { useProductsPrices } from "utils/selectors";

const PrimariesDisplayList = ({ primaries, autoTaxes }) => {
  const { prices, products } = useProductsPrices();

  return primaries.reduce((memo, model) => {
    const productMatch = products.find((prod) => prod.id === model.product);
    const priceMatch = prices.find((price) => price.id === model.price);

    if (productMatch && priceMatch) {
      return (
        <div
          key={model.price}
          className={classnames("w-100 flex flex-column pl1", {
            pt3: memo.length
          })}
        >
          <div className="flex flex-column flex-row-ns justify-between items-center-ns">
            <div className="flex flex-row justify-between items-center w-100">
              <div className="flex flex-column w-100">
                <div className="fw6 f5 pr2 lh-title">{productMatch.name}</div>
                <PriceInfo
                  price={priceMatch}
                  model={model}
                  autoTaxes={autoTaxes}
                />
              </div>
            </div>
          </div>
        </div>
      );
    }

    return memo;
  }, []);
};

export default PrimariesDisplayList;
